export const DRAG_THRESHOLD = 30
export const REPLY_THRESHOLD = 40
export const DRAG_OFFSET_LIMIT = 60
